module.exports = "<sq-report-template-thumbnail></sq-report-template-thumbnail>\n";